// extracted by mini-css-extract-plugin
module.exports = {"limited-no-active-events":"no-event_limited-no-active-events__c3c9P"};